import { render, staticRenderFns } from "./addApproverToWorkflow.vue?vue&type=template&id=79e3b48e&scoped=true"
import script from "./addApproverToWorkflow.vue?vue&type=script&lang=js"
export * from "./addApproverToWorkflow.vue?vue&type=script&lang=js"
import style0 from "./addApproverToWorkflow.vue?vue&type=style&index=0&id=79e3b48e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e3b48e",
  null
  
)

export default component.exports